import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.262 5h21.475a2.001 2.001 0 0 1 1.477 3.348l-.001.002-1.366 1.503a1 1 0 1 1-1.48-1.345l1.368-1.506.002-.002H5.263l.002.002 8.209 9.034c.341.368.53.853.526 1.355v9.736l4-2.662a1 1 0 0 1 2-.012 1.99 1.99 0 0 1-.9 1.682l-3.996 2.66-.004.003a2 2 0 0 1-3.1-1.65v-9.76l-.003-.003-8.21-9.035-.001-.001A2 2 0 0 1 5.262 5"
    />
    <path
      fill="currentColor"
      d="M25.207 12.793a1 1 0 0 1 0 1.414L22.914 16.5l2.293 2.293a1 1 0 0 1-1.414 1.414L21.5 17.914l-2.293 2.293a1 1 0 0 1-1.414-1.414l2.293-2.293-2.293-2.293a1 1 0 0 1 1.414-1.414l2.293 2.293 2.293-2.293a1 1 0 0 1 1.414 0"
    />
  </svg>
);
const SvgIconFunnelX = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconFunnelX);
export default Memo;
